export default __webpack_public_path__ + "static/media/pag34.241827b0.jpg";